import React from 'react';

import {
  BrowserRouter as Router,
  Switch,
  Route,
} from "react-router-dom";

import ProtectedRoute from './services/auth/ProtectedRoute'

// COMPONENTS //

import Home from './components/Home'
import Login from './components/Login'
import Register from './components/Register';
import CompleteRegister from './components/Register/CompleteRegister'
import Profile from './components/Profile'
import Device from './components/Device'
import Place from './components/Place'
import Financial from './components/Financial';
import TelegramLink from './components/TelegramLink'
import RegisterUser from './components/RegisterUser'

import Directions from './components/Travel/'
import Plans from './components/Plans';
import Localizator from './components/Localizator';
import ForgotPassword from './components/ForgotPassword';
import ResetPassword from './components/ForgotPassword/ResetPassword';
import Settings from './components/Settings';
import AccountDevice from './components/AccountDevice';
import UpdateFirmware from './components/UpdateFirmware';
import EmailConfirmation from './components/EmailConfirmation';
import DeviceHistory from './components/DeviceHistory'
import EnterpriseScreen from './components/AddBeacon/EnterpriseScreen';
import UserScreen from './components/AddBeacon/UserScreen';
import AddBeacon from './components/AddBeacon';
import EditUser from './components/AddBeacon/EditUser';
import ClientDevices from './components/AccountDevices';
import AccountUsers from './components/AccountUsers';
import RegisterEnterprise from './components/RegisterEnterprise';
import AccessLog from './components/AccessLog'
import Reports from './components/Reports'

import withClearCache from "./ClearCache";

const ClearCacheComponent = withClearCache(MainApp);

function App() {
  return <ClearCacheComponent />;
}

function MainApp(props) {
  return (
    <Router>
      <Switch>
        <Route exact path="/" component={Home} />
        <Route exact path="/login" component={Login} />
        <Route exact path="/register" component={Register} />
        <Route exact path="/forgot-password" component={ForgotPassword} />
        <Route exact path="/reset-password" component={ResetPassword} />
        <Route exact path="/complete-register" component={CompleteRegister} />
        <Route exact path="/telegram/:chatId/login" component={TelegramLink} />
        <Route exact path="/localizator" component={Localizator} />
        <Route exact path="/confirmation/:token" component={EmailConfirmation} />
        <Route exact path="/register-user" component={RegisterUser} />
        <Route exact path="/register-enterprise" component={RegisterEnterprise} />
        <Route exact path="/add-beacons" component={AddBeacon} />
        <Route exact path="/enterprises" component={EnterpriseScreen} />
        <Route exact path="/select-user" component={UserScreen} />
        <Route exact path="/edit-user" component={EditUser} />
        <Route exact path="/client-devices" component={ClientDevices} />
        <Route exact path="/enterprise-users" component={AccountUsers} />
        <ProtectedRoute exact path="/profile" component={Profile} />
        <ProtectedRoute exact path="/acess-log" component={AccessLog} />
        <ProtectedRoute exact path="/plans" component={Plans} />
        <ProtectedRoute exact path="/my-devices" component={AccountDevice} />
        <ProtectedRoute exact path="/locations" component={Place} />
        <ProtectedRoute exact path="/reports" component={Reports} />
        <ProtectedRoute exact path="/financial" component={Financial} />
        <ProtectedRoute exact path="/directions" component={Directions} />
        <ProtectedRoute exact path="/firmware" component={UpdateFirmware} />
        <ProtectedRoute exact path="/settings" component={Settings} />
        <ProtectedRoute exact path="/device-history/:mac/:id" component={DeviceHistory} />
      </Switch>
    </Router>
  );
}

export default App;
